import { HttpClient, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { MatSnackBar } from "@angular/material/snack-bar";
import { Router } from "@angular/router";
import { catchError, finalize, map } from "rxjs/operators";
import { environment } from "src/environments/environment";
import { Invoice } from "../domain/invoice";
import { CoreData } from "../tools/core-data/core-data";
import { LoadingTask } from "../tools/ui/loading-task";
import { BaseService } from "./base-service";

@Injectable({
    providedIn: 'root',
})
export class InvoiceService extends BaseService {

    private serviceUrl = `${environment.serviceBaseUrl}api/apave`;

    constructor(public http: HttpClient,
        protected coreData: CoreData,
        protected snackBare: MatSnackBar,
        private loadingTask: LoadingTask,
        protected router: Router,
    ) {

        super(router, coreData, snackBare);
    }

    getInvoices() {
        this.loadingTask.activateLoading();

        return this.http.get(`${this.serviceUrl}/getInvoices`, this.generateHeader()).pipe(
            catchError(this.handleError<any>('getInvoices')),
            finalize(() => this.loadingTask.deactivateLoading()),
            map((response: Invoice[]) => {
                console.log(response);
                return response.map((item: Invoice) => {
                    return Invoice.mapFromJSON(item);
                });
            }));
    }
    SetPurchaseOrderCode(invoiceCode: string, purchaseOrderCode: string) {
        this.loadingTask.activateLoading();

        return this.http.put(`${this.serviceUrl}/SetPO/${invoiceCode}/${purchaseOrderCode}`, null, this.generateHeader()).pipe(
            catchError(this.handleError<any>('SetPurchaseOrderCode')),
            finalize(() => this.loadingTask.deactivateLoading()),
            map((response: boolean) => {
                return response;
            }));
    }

    getDocument(invoice: string) {
        this.loadingTask.activateLoading();

        return this.http.get(`${this.serviceUrl}/GetExcel/${invoice}`, this.generateHeaderForBlobDownload())
            .pipe(
                catchError(this.handleError<any>('getDocument')),
                finalize(() => this.loadingTask.deactivateLoading()));
    }

}